// #root — статическая разметка index.html перед module-скриптом, поэтому лукап
// на импорте всегда резолвится. Общий для всех оверлеев.
export const portalContainer = document.getElementById("root")
